import {Box, Button, CircularProgress, IconButton} from "@mui/material";
import {useEffect, useState} from "react";
import {FiEdit2, FiTrash2} from "react-icons/fi";
import {useLocation, useNavigate} from "react-router-dom";
import ClientForm from "../components/Clients/ClientForm";
import ClientInfo from "../components/Clients/ClientInfo";
import ClientScopesGrid from "../components/Clients/ClientScopesGrid";
import Window from "../components/Window/Window";
import ConfirmDialog from "../components/ui/ConfirmDialog";
import useApiRequest from "../hooks/useApiRequest";
import useConfirmDialog from "../hooks/useConfirmDialog";

const ClientDetail = () => {
  const {state} = useLocation();
  const navigate = useNavigate();
  const id = state?.id;

  const isNewClient = !id;

  const {data, loading, read, remove} = useApiRequest({baseUrl: `/clients`, resource: "clients"});

  const [isEditing, setIsEditing] = useState(isNewClient);

  // Hook para el diálogo de confirmación
  const {confirmOpen, itemName, openDialog, handleConfirm, handleCancel} = useConfirmDialog(async () => {
    try {
      await remove(id);
      navigate("/clients");
    } catch (error) {
      console.error("Error al eliminar el cliente:", error);
    }
  });

  useEffect(() => {
    if (!isNewClient) {
      (async () => {
        try {
          await read(id);
        } catch (error) {
          console.error("Error al cargar el cliente:", error);
        }
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleEditToggle = () => {
    setIsEditing(!isEditing);
  };

  const handleOpenDeleteDialog = () => {
    openDialog(id, data?.name || "");
  };

  return (
    <>
      <Window title={isNewClient ? "Nuevo Cliente" : "Detalles del Cliente"}>
        <Box sx={{padding: 2}}>
          {loading && !isNewClient ? (
            <CircularProgress />
          ) : (
            <Box>
              <Box sx={{display: "flex", gap: 2}}>
                {isEditing ? (
                  <ClientForm
                    isNew={isNewClient}
                    refreshData={async () => {
                      try {
                        await read(id);
                      } catch (error) {
                        console.error("Error al cargar el cliente:", error);
                      }
                    }}
                    setIsEditing={setIsEditing}
                    initialClientData={data}
                  />
                ) : (
                  <ClientInfo client={data} />
                )}

                <Box sx={{marginLeft: "auto"}}>
                  {!isNewClient &&
                    (isEditing ? (
                      <Button variant="contained" color="primary" onClick={handleEditToggle}>
                        Cancelar
                      </Button>
                    ) : (
                      <IconButton aria-label="edit" color="primary" onClick={handleEditToggle}>
                        <FiEdit2 />
                      </IconButton>
                    ))}
                  {!isNewClient && (
                    <IconButton aria-label="delete" color="secondary" onClick={handleOpenDeleteDialog}>
                      <FiTrash2 />
                    </IconButton>
                  )}
                </Box>
              </Box>
            </Box>
          )}
        </Box>

        {!isNewClient && <ClientScopesGrid clientId={id} />}
      </Window>

      <ConfirmDialog
        open={confirmOpen}
        onClose={handleCancel}
        onConfirm={handleConfirm}
        entityName="cliente"
        entityLabel={itemName}
      />
    </>
  );
};

export default ClientDetail;
